export const RouteGetMerchflowsExportsCsvColumns =
  "/merchflows/exports/csv/columns";

export type PogCsvDataset = "ranged" | "unranged";

export interface QueryGetMerchflowsExportsCsvColumns {
  csvDataset?: PogCsvDataset;
}

export interface ResponseGetMerchflowsExportsCsvColumns {
  columns: Array<{
    key: string;
    label: string;
    group: string;
    defaultSelected: boolean;
  }>;
  selectedColumns: string[];
}
